/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Yükleniyor"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var trTR = Object.assign(TranslationProviderComponent, {
  translations
});

export { trTR as t };
//# sourceMappingURL=tr-TR-C49Q0e4B.js.map
